import React from 'react';
import { PopUpNotification } from 'extracted-chat-components';

import {
  ButtonColor,
  ButtonShape,
  ButtonSize,
} from 'constants/enums';
import { PaymentFailedProps } from 'types/componentTypes';

const PaymentFailed: React.FC<PaymentFailedProps> = ({
  isNotificationPopUp,
  popUpNotificationData,
  showPopUpNotification,
}) => {
  const handleAcceptButton = () => {
    showPopUpNotification(false);
  };

  const acceptButton = {
    text: 'Okay',
    color: ButtonColor.WARNING,
    size: ButtonSize.XS,
    shape: ButtonShape.ROUNDED,
    handler: handleAcceptButton,
  };

  return (
    <PopUpNotification
      isOpen={isNotificationPopUp}
      title={popUpNotificationData.title}
      description={popUpNotificationData.description}
      acceptButton={acceptButton}
      isBigWidth={false}
    />
  );
};

export default PaymentFailed;
